import MultiMetricCard from './MultiMetricCard'
import React from 'react'

export default function PropertyMetrics({ economyStats, loading }) {
	const metrics = [
		{
			icon: 'fa-home',
			color: 'text-primary',
			value: economyStats?.stat_rentable_total || 0,
			label: 'Objekt'
		},
		{
			icon: 'fa-users',
			color: 'text-warning',
			value: economyStats?.stat_tenants_current || 0,
			label: 'Hyresgäster'
		},
		{
			icon: 'fa-expand-arrows-alt',
			color: 'text-info',
			value: economyStats?.stat_area_average ? `${economyStats.stat_area_average} m²` : '0 m²',
			label: 'Snitt yta',
			tooltip: 'Snitt yta'
		},
		{
			icon: 'fa-calculator',
			color: 'text-success',
			value: economyStats ? new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK', minimumFractionDigits: 0 }).format(economyStats.stat_area_average_price) : '...',
			label: 'Hyra per m²',
			tooltip: 'Hyra per m²'
		}
	]

	return (
		<MultiMetricCard
			title="Dina uthyrningsbara objekt"
			icon="fa fa-building"
			metrics={metrics}
			loading={loading}
		/>
	)
}
